import { Divider } from "@mui/material";
import { RiCircleFill } from "@remixicon/react";
import moment from "moment";

interface NotificationTileProps {
  isRead?: boolean;
  title: string;
  description: string;
  arrivedAt: string;
  onNotClick: () => void;
}

export default function NotificationTile({
  isRead = false,
  title,
  description,
  arrivedAt,
  onNotClick,
}: NotificationTileProps) {
  return (
    <div
      className={`flex flex-col w-full ${isRead ? "bg-transparent" : "bg-shblue-50"}`}
      onClick={onNotClick}
    >
      <div className="flex flex-row items-center w-full gap-2 p-3">
        <RiCircleFill
          size="16"
          className={`${isRead ? "text-transparent" : "text-shblue-500"}`}
        />
        <div className="flex flex-col w-full">
          <div className="flex items-center justify-between w-full">
            <span className="font-bold">{title}</span>
            <span className="text-sm font-semibold">
              {moment(arrivedAt).isValid() && moment(arrivedAt).fromNow()}
            </span>
          </div>
          <span className="text-secondary-700">{description}</span>
        </div>
      </div>
      <Divider />
    </div>
  );
}
